// Mock data for KAIROS website

export const heroData = {
  tagline: "L'art du moment décisif dans la création numérique",
  subtitle: "Développement web et plateformes sur-mesure où chaque ligne de code est une opportunité saisie",
  cta: "Discutons de votre moment Kairos",
  email: "moment@kairos.dev"
};

export const philosophyData = {
  chronos: {
    title: "CHRONOS",
    subtitle: "Ce que nous ne sommes pas",
    description: "Le temps linéaire, quantitatif",
    points: [
      { label: "Mesure", value: "Heures / Jours" },
      { label: "Approche", value: "Combien de temps ça prend?" },
      { label: "Résultat", value: "Délais respectés, coûts contrôlés" },
      { label: "Métaphore", value: "Sablier, timeline Gantt" }
    ]
  },
  kairos: {
    title: "KAIROS",
    subtitle: "Ce que nous sommes",
    description: "Les moments opportuns, qualitatifs",
    points: [
      { label: "Mesure", value: "Opportunités saisies" },
      { label: "Approche", value: "Quel est le moment décisif?" },
      { label: "Résultat", value: "Avantage concurrentiel, pivot stratégique" },
      { label: "Métaphore", value: "Point d'inflexion sur une courbe" }
    ]
  }
};

export const approachData = [
  {
    id: 1,
    phase: "01",
    title: "DIAGNOSTIC KAIROS",
    duration: "2-3 semaines",
    tagline: "Identifier le moment décisif de votre transformation",
    points: [
      "Cartographie des opportunités et contraintes",
      "Identification du point d'inflexion stratégique",
      "Définition des métriques de succès qualitatives"
    ]
  },
  {
    id: 2,
    phase: "02",
    title: "ARCHITECTURE DE L'OPPORTUNITÉ",
    duration: "1-2 semaines",
    tagline: "Forger les fondations de votre avantage",
    points: [
      "Design system stratégique",
      "Architecture technique scalable",
      "Plan de déploiement par moments opportuns"
    ]
  },
  {
    id: 3,
    phase: "03",
    title: "DÉVELOPPEMENT PRÉCIS",
    duration: "Variable",
    tagline: "Créer avec l'exactitude d'un horloger",
    points: [
      "Code comme artisanat",
      "Revue continue de l'opportunité stratégique",
      "Itérations basées sur des insights, pas des délais"
    ]
  },
  {
    id: 4,
    phase: "04",
    title: "DÉPLOIEMENT STRATÉGIQUE",
    duration: "Sur mesure",
    tagline: "Saisir le moment de la mise en lumière",
    points: [
      "Lancement calibré sur les opportunités marché",
      "Transfert de connaissance stratégique",
      "Mesure de l'impact sur le point d'inflexion"
    ]
  }
];

export const principlesData = [
  "Nous préférons un projet complexe qui transforme à un projet simple qui comble.",
  "Le bon code au mauvais moment est un échec stratégique.",
  "Nous ne construisons pas des fonctionnalités, nous créons des leviers d'opportunité.",
  "L'élégance technique est la discrétion de l'efficacité.",
  "Chaque ligne de code doit justifier son moment de création."
];

export const expertisesData = [
  {
    id: 1,
    title: "ARCHITECTURES DÉCISIVES",
    description: "Plateformes qui deviennent l'avantage concurrentiel",
    icon: "Layers"
  },
  {
    id: 2,
    title: "SYSTÈMES DE CROISSANCE",
    description: "Outils qui identifient et exploitent les moments Kairos de scaling",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "INTERFACES D'OPPORTUNITÉ",
    description: "UX qui guide l'utilisateur vers ses moments décisifs",
    icon: "Sparkles"
  },
  {
    id: 4,
    title: "INFRASTRUCTURES DE PRÉCISION",
    description: "Environnements techniques qui permettent la saisie d'opportunités",
    icon: "Server"
  },
  {
    id: 5,
    title: "AUTOMATISATIONS STRATÉGIQUES",
    description: "Processus qui transforment le chronos en kairos",
    icon: "Zap"
  },
  {
    id: 6,
    title: "TRANSFORMATION NUMÉRIQUE",
    description: "Accompagnement pour identifier et saisir les moments de transformation",
    icon: "Compass"
  }
];

export const contactData = {
  email: "moment@kairos.dev",
  intro: "Nous sélectionnons nos partenariats avec soin.",
  description: "Un email clair décrivant votre contexte et votre moment décisif sera toujours préféré à un formulaire.",
  responseTime: "Nous répondons sous 48 heures aux opportunités alignées."
};
